import { render } from "./SaasServicesPage.vue?vue&type=template&id=1093597a&scoped=true"
import script from "./SaasServicesPage.vue?vue&type=script&lang=js"
export * from "./SaasServicesPage.vue?vue&type=script&lang=js"

import "./SaasServicesPage.vue?vue&type=style&index=0&id=1093597a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1093597a"]])

export default __exports__